var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames } from '../../utils/style-class.utils';
import * as styles from './divider.styles';
export function Divider(_a) {
    var title = _a.title, _b = _a.dividerType, dividerType = _b === void 0 ? 'solid' : _b, className = _a.className;
    return (_jsxs("div", __assign({ className: classNames(className ? className : '', styles.dividerContainer) }, { children: [_jsx("div", __assign({ className: styles.dividerWrapper }, { children: _jsx("div", { className: classNames(styles.divider, 'border-' + dividerType) }) })), title && (_jsx("div", __assign({ className: styles.titleContainer }, { children: _jsx("span", __assign({ className: styles.title }, { children: title })) })))] })));
}
export default Divider;
//# sourceMappingURL=divider.js.map